/**
 * Authorization Roles
 */
const authRoles = {
	admin: ["admin"],
	staff: ["admin", "staff"],
	wait: ["admin", "staff", "wait"],
	user: ["admin", "staff", "wait", "user"],
	onlyGuest: [],
};

export default authRoles;
